import { AiOutlineDownload } from "react-icons/ai";
import { Typography, Button, Table, TableFooter, Tag } from "components";
import { useEffect } from "react";
import { terminalStatuses } from "utils/constants";

const TerminalStatusesTable = ({
  loading,
  terminalStatusesData,
  terminalStatusesQuery,
  getTerminalStatusesData,
  downloadTerminalStatuses,
  handleTerminalStatusQueryChange,
}) => {
  const getStatusTag = (value) => {
    let terminal = terminalStatuses.find((status) => status.mapper === value);

    const { text, bgColor, color } = terminal || {};
    return terminal ? (
      <Tag text={text} backgroundColor={bgColor} textColor={color} />
    ) : (
      value
    );
  };

  const columns = [
    {
      Header: "S/N",
      Cell: ({ row }) => Number(row.id) + 1,
    },
    {
      Header: "OEM Name",
      accessor: "oem",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Terminal ID",
      accessor: "terminalId",
      Cell: ({ value }) => value || "-",
    },

    {
      Header: "Serial N0.",
      accessor: "serialNumber",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "IMEI",
      accessor: "imei",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "PM Number",
      accessor: "pmNumber",
      Cell: ({ value }) =>
        value?.map((val, i) => (
          <Typography key={i} variant="caption1">
            {val}
            {i === value?.length - 1 ? "." : ","} &nbsp;
          </Typography>
        )),
    },
    {
      Header: "Email",
      accessor: "agentEmail",
    },
    {
      Header: "Region",
      accessor: "region",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "State",
      accessor: "state",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Address",
      accessor: "terminalAddress",
      Cell: ({ value }) => value || "-",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: (props) => (
        <div className="d-flex justify-content-center">
          {getStatusTag(props.value)}
        </div>
      ),
      customWidth: "10rem",
    },
  ];

  const { category, size, number } = terminalStatusesQuery;

  useEffect(() => {
    getTerminalStatusesData();

    //eslint-disable-next-line
  }, [category, number, size]);

  const tableData = terminalStatusesData?.content;

  return (
    <div>
      <Typography state="grey" variant={"body2"}>
        Preview Report Generated
      </Typography>
      <div className="d-flex justify-content-between my-4">
        <Typography variant={"body4"} state="primary">
          Total ({terminalStatusesData?.totalElements})
        </Typography>
        <Button
          label="Download Report"
          className={"report-download-cta"}
          endIcon={<AiOutlineDownload />}
          onClick={downloadTerminalStatuses}
          disabled={!tableData?.length}
        />
      </div>
      <Table columns={columns} data={tableData || []} loading={loading} />
      {tableData.length ? (
        <TableFooter
          pageSize={size}
          forcePage={number}
          handleChange={(e) => {
            handleTerminalStatusQueryChange({
              name: "size",
              value: e.target.value,
            });
          }}
          availableDataLength={tableData?.length}
          totalDataLength={terminalStatusesData?.totalElements}
          handlePageClick={(pageNo) => {
            handleTerminalStatusQueryChange({
              name: "number",
              value: pageNo,
            });
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default TerminalStatusesTable;
